import { WidgetsParcelEditMain } from '@/widgets/parcel-edit';

export const PagesParcelEditMain = () => <WidgetsParcelEditMain />;
